export default __webpack_public_path__ + "static/media/steps.b3f73a9f.svg";